import { Rpc } from "rpc/rpc";
import { ValueWrapper } from "rpc/ValueWrapper";


export class TeamHolidaysRpc {

    public static list(y: number): Promise<TeamHolidaysListResponse> {
        var url: string = "/rpc/statistics/teamholidays/list"
        if (y != null) {
            url += "?y=" + y
        }
        return Rpc.GET(url);
    }

    private constructor() {}

}

export interface TeamHolidaysListResponse {

    readonly items: TeamHolidaysListItem[];
    readonly extraTitles: string[];

}

export interface TeamHolidaysListItem {

    readonly userId: number;
    readonly userName: string;
    readonly yearlyVacationCount: string;
    readonly rolledVacationCount: string;
    readonly usedUpVacationCount: string;
    readonly remainingVacationCount: string;
    readonly otherItems: string[];

}